/* SleepKarma — Nose Tape PDP behaviour (gallery, pack selector, refill,
   cart-drawer add-to-cart, review carousel, video modal, scroll reveal).
   Ported from the designer's V1 build. PRODUCT falls back to window.SK_PRODUCT
   so the product-template phase can inject live variant/selling-plan data;
   galleryImages falls back to window.SK_NOSE_GALLERY (Liquid file_url). */

// ==================================================
// PRODUCT DATA — All variant IDs, selling plans, pricing
// ==================================================
// Live Shopify data — Premium Bamboo Nose Tape (gid 8781444841713, handle: nose-tape)
// Selling plans are the shared Skio plans: 30% / 45% / 50% off.
const PRODUCT = window.SK_PRODUCT || {
  variants: {
    '1':  { id: 46045510107377, title: 'Nose Tape / 1 Month Supply'  },
    '3':  { id: 46045510172913, title: 'Nose Tape / 3 Months Supply' },
    '6':  { id: 46045510238449, title: 'Nose Tape / 6 Months Supply' },
  },
  sellingPlans: {
    '1': { id: 5171773681, price: 2728, label: '$27.28', save: '30%' },
    '3': { id: 5171740913, price: 2143, label: '$21.43', save: '45%' },
    '6': { id: 5171806449, price: 1949, label: '$19.49', save: '50%' },
  },
  oneTimePricePerMonth: 3897,
  // Pack pricing — one-time totals (live Shopify variant prices)
  packs: {
    '1': { months: 1, oneTimeTotal: '$38.97',   oneTimeOrig: null, perMonth: '$38.97' },
    '3': { months: 3, oneTimeTotal: '$116.91',  oneTimeOrig: null, perMonth: '$38.97' },
    '6': { months: 6, oneTimeTotal: '$233.82',  oneTimeOrig: null, perMonth: '$38.97' },
  },
  // Subscription totals per pack
  subPacks: {
    '1': { total: '$27.28',  orig: '$38.97',  perMonth: '$27.28', save: '30%' },
    '3': { total: '$64.30',  orig: '$116.91', perMonth: '$21.43', save: '45%' },
    '6': { total: '$116.91', orig: '$233.82', perMonth: '$19.49', save: '50%' },
  },
};

// ==================================================
// STATE
// ==================================================
let state = {
  pack: '3',             // '1', '3', or '6' — default to 3 month (most popular)
  isSubscription: true,  // refill toggle on by default
};

// Anything with role="button" that is not a real <button> still needs a
// keyboard path. One delegated listener covers the gallery thumbs, pack
// cards, the refill toggle and the review videos.
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
  const el = e.target.closest('[role="button"]');
  if (!el || el.tagName === 'BUTTON') return;
  e.preventDefault();
  el.click();
});

// ==================================================
// IMAGE GALLERY
// ==================================================
var galleryImages = window.SK_NOSE_GALLERY || [
  'Page Images/01-hero-product.jpg',
  'Page Images/02-reasons-sleep.jpg',
  'Page Images/03-reasons-performance.jpg',
  'Page Images/03b-reasons-appearance.jpg',
  'Page Images/04-materials-safety.jpg',
  'Page Images/05-vs-other-tapes.jpg',
  'Page Images/06-how-to-use.jpg',
  'Page Images/07-customer-review.jpg',
  'Page Images/07b-customer-review-sport.jpg',
  'Page Images/08-whats-in-the-box.jpg',
];

let currentImageIndex = 0;
function setImage(index) {
  currentImageIndex = index;
  document.getElementById('main-image').src = galleryImages[index];
  document.getElementById('gallery-counter').textContent = (index + 1) + ' / ' + galleryImages.length;
  document.querySelectorAll('.gallery-thumb').forEach((t, i) => {
    t.classList.toggle('active', i === index);
  });
  // Show/hide arrows based on position
  const prevBtn = document.querySelector('.gallery-arrow.prev');
  const nextBtn = document.querySelector('.gallery-arrow.next');
  if (prevBtn) prevBtn.classList.toggle('hidden', index === 0);
  if (nextBtn) nextBtn.classList.toggle('hidden', index === galleryImages.length - 1);
}
function prevImage() {
  if (currentImageIndex > 0) setImage(currentImageIndex - 1);
}
function nextImage() {
  if (currentImageIndex < galleryImages.length - 1) setImage(currentImageIndex + 1);
}

// Swipe support (touch + mouse drag)
(function() {
  var el = document.getElementById('gallery-main');
  if (!el) return;
  var startX, startY, isDragging = false;

  // Prevent native image drag on ALL images inside gallery
  var imgs = el.getElementsByTagName('img');
  for (var i = 0; i < imgs.length; i++) {
    imgs[i].draggable = false;
    imgs[i].addEventListener('dragstart', function(e) { e.preventDefault(); });
  }

  function getX(e) {
    if (e.touches) return e.touches[0].clientX;
    return e.clientX;
  }
  function getY(e) {
    if (e.touches) return e.touches[0].clientY;
    return e.clientY;
  }
  function getEndX(e) {
    if (e.changedTouches) return e.changedTouches[0].clientX;
    return e.clientX;
  }
  function getEndY(e) {
    if (e.changedTouches) return e.changedTouches[0].clientY;
    return e.clientY;
  }

  function onStart(e) {
    isDragging = true;
    startX = getX(e);
    startY = getY(e);
    // Only preventDefault for mouse (not touch, to allow scroll)
    if (!e.touches) e.preventDefault();
  }
  function onEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    var dx = getEndX(e) - startX;
    var dy = getEndY(e) - startY;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) { nextImage(); } else { prevImage(); }
    }
  }
  function onCancel() { isDragging = false; }

  // Touch
  el.addEventListener('touchstart', onStart, { passive: true });
  el.addEventListener('touchend', onEnd);
  el.addEventListener('touchcancel', onCancel);

  // Mouse
  el.addEventListener('mousedown', onStart);
  window.addEventListener('mouseup', onEnd);
  window.addEventListener('mouseleave', onCancel);

  // Also set cursor style
  el.style.cursor = 'grab';
  el.addEventListener('mousedown', function() { el.style.cursor = 'grabbing'; });
  window.addEventListener('mouseup', function() { el.style.cursor = 'grab'; });
})();

// ==================================================
// PACK SELECTION
// ==================================================
function selectPack(pack) {
  state.pack = pack;
  document.querySelectorAll('.pack-card').forEach(c => c.classList.remove('selected'));
  document.querySelector('.pack-card[data-pack="' + pack + '"]').classList.add('selected');
  updatePackCards();
  updateUI();
}

// ==================================================
// REFILL / SUBSCRIBE TOGGLE
// ==================================================
function toggleRefill() {
  state.isSubscription = !state.isSubscription;
  const toggle = document.getElementById('refill-toggle');
  const check = document.getElementById('refill-check');
  toggle.classList.toggle('active', state.isSubscription);
  document.getElementById('refill-row').classList.toggle('active', state.isSubscription);
  check.textContent = state.isSubscription ? '✓' : '';
  document.querySelector('.pack-cards').classList.toggle('compact', !state.isSubscription);
  var bestDeal = document.querySelector('.pack-badge.best-deal');
  if (bestDeal) bestDeal.style.display = state.isSubscription ? '' : 'none';
  updatePackCards();
  updateUI();
}

// ==================================================
// UPDATE PACK CARD PRICES (when toggling subscription)
// ==================================================
function updatePackCards() {
  ['1', '3', '6'].forEach(p => {
    const perMonthEl = document.getElementById('pack-' + p + '-permonth');
    const origEl = document.getElementById('pack-' + p + '-orig');
    const totalEl = document.getElementById('pack-' + p + '-total');
    const discountEl = document.getElementById('pack-' + p + '-discount');

    if (state.isSubscription) {
      const sub = PRODUCT.subPacks[p];
      perMonthEl.innerHTML = sub.perMonth + '<span class="pack-price-permonth-label">/mo</span>';
      origEl.textContent = PRODUCT.packs[p].perMonth;
      origEl.style.visibility = 'visible';
      discountEl.textContent = sub.save + ' OFF';
      discountEl.style.display = '';
      if (totalEl) { totalEl.textContent = sub.total + ' total'; }
    } else {
      const pack = PRODUCT.packs[p];
      perMonthEl.innerHTML = pack.perMonth + '<span class="pack-price-permonth-label">/pack</span>';
      origEl.style.visibility = 'hidden';
      discountEl.style.display = 'none';
      if (totalEl) {
        totalEl.textContent = pack.oneTimeTotal + ' total';
      }
    }
  });

  // Update "You save $X" box — calculate actual dollar savings
  const saveBox = document.getElementById('refill-save-box');
  if (state.isSubscription) {
    const months = parseInt(state.pack);
    const oneTimeTotal = PRODUCT.oneTimePricePerMonth * months; // in cents
    const subTotal = parseFloat(PRODUCT.subPacks[state.pack].total.replace('$', '').replace(',', '')) * 100;
    const saved = ((oneTimeTotal - subTotal) / 100).toFixed(2);
    saveBox.textContent = 'You save $' + saved;
  }

  // Toggle subscription benefits + delivery line visibility
  document.querySelectorAll('.pack-benefits, .pack-deliver').forEach(el => {
    if (state.isSubscription) {
      el.classList.add('visible');
    } else {
      el.classList.remove('visible');
    }
  });
}

// ==================================================
// UI UPDATE — main price row, CTA, sticky bar
// ==================================================
function updateUI() {
  const total = state.isSubscription
    ? PRODUCT.subPacks[state.pack].total
    : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : null;

  // Rebuild the whole CTA button from current state. resetCTAButton() is the
  // single source of truth for the button's markup, so the price row can never
  // get stuck after add-to-cart replaces the button with "Added!"/loading and
  // removes the #cta-price / #cta-original spans (e.g. on bfcache return).
  resetCTAButton();

  // Update sticky bar
  const stickyPriceEl = document.getElementById('sticky-price');
  if (stickyPriceEl) {
    if (state.isSubscription) {
      stickyPriceEl.innerHTML = total + ' <span style="text-decoration:line-through;color:var(--gray-400);font-weight:400;">' + origTotal + '</span>';
    } else {
      stickyPriceEl.textContent = total;
    }
  }
}

// Returning to the page (fresh load OR back/forward-cache restore) must re-sync
// the CTA + sticky bar, otherwise a button left in the "Added!" state after a
// previous add-to-cart stays frozen and stops responding to pack changes.
window.addEventListener('pageshow', function () { updateUI(); });

// ==================================================
// START NOW — Shopify AJAX Cart API
// ==================================================
function addToCart() {
  var btn = document.getElementById('add-to-cart-btn');
  var successEl = document.getElementById('cart-success');

  // Nose tape: the pack (1/3/6) IS the variant — quantity is always 1.
  var variant = PRODUCT.variants[state.pack];
  if (!variant) { alert('Error: Could not find variant. Please try again.'); return; }

  var payload = { id: variant.id, quantity: 1 };
  if (state.isSubscription) { payload.selling_plan = PRODUCT.sellingPlans[state.pack].id; }

  btn.classList.add('loading');
  btn.innerHTML = '⏳ Adding to cart...';

  // Section IDs the theme's cart drawer needs to re-render itself.
  var cartDrawer = document.querySelector('cart-drawer');
  var drawerSections = cartDrawer && cartDrawer.getSectionsToRender
    ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
    : ['cart-drawer', 'cart-icon-bubble'];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [payload], sections: drawerSections.join(',') })
  })
  .then(function (r) { if (!r.ok) throw new Error('Cart API returned ' + r.status); return r.json(); })
  .then(function (data) {
    btn.classList.remove('loading');
    btn.innerHTML = '✅ Added!';
    // renderContents() swaps in fresh drawer HTML, then we open it.
    if (cartDrawer && cartDrawer.renderContents && data.sections) {
      cartDrawer.renderContents(data, true);
      setTimeout(function () { if (!cartDrawer.isOpen) { cartDrawer.toggleDrawerClasses(); } }, 100);
    } else {
      setTimeout(function () {
        var t = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
        if (t) t.click();
      }, 500);
    }
    setTimeout(function () { resetCTAButton(); }, 3000);
  })
  .catch(function (error) {
    btn.classList.remove('loading');
    var isShopify = window.location.hostname.indexOf('sleepkarma') > -1 || window.location.hostname.indexOf('myshopify') > -1;
    if (isShopify) {
      btn.innerHTML = '❌ Error — please try again';
      setTimeout(function () { resetCTAButton(); }, 2000);
    } else {
      var price = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
      successEl.innerHTML = '<div class="cart-success-text">🔧 Preview Mode — This would add to cart:</div>' +
        '<div style="font-size:13px;color:#555;margin-bottom:8px;">Variant: <strong>' + variant.title + '</strong> (ID: ' + variant.id + ')<br>' +
        (state.isSubscription ? 'Selling Plan: <strong>' + state.pack + '-month subscription</strong> (ID: ' + PRODUCT.sellingPlans[state.pack].id + ')<br>' : 'One-time purchase<br>') +
        'Price: <strong>' + price + '</strong></div>';
      successEl.classList.add('show');
      resetCTAButton();
    }
  });
}

function resetCTAButton() {
  const btn = document.getElementById('add-to-cart-btn');
  const total = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : '';
  btn.innerHTML = '<span class="cta-lock"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span> START NOW — <span class="cta-price">' + total + '</span>' + (state.isSubscription ? ' <span class="cta-original">' + origTotal + '</span>' : '');
}

// ==================================================
// BB FAQ TOGGLE — lock scroll position for full animation
// ==================================================
function bbFaqToggle(btn) {
  var scrollY = window.scrollY;
  btn.parentElement.classList.toggle('open');
  // Lock scroll for the entire 450ms transition
  var id = setInterval(function() { window.scrollTo(0, scrollY); }, 16);
  setTimeout(function() { clearInterval(id); }, 500);
}

// ==================================================
// STICKY BAR — IntersectionObserver
// ==================================================
const heroCta = document.getElementById('add-to-cart-btn');
const finalCta = document.querySelector('.final-cta-button');
const stickyBar = document.getElementById('sticky-bar');
let heroBelowViewport = false, finalCtaVisible = false;
const stickyUpdate = () => stickyBar.classList.toggle('visible', heroBelowViewport && !finalCtaVisible);
const heroObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    // Show sticky only when CTA is above viewport (user scrolled past it downward)
    heroBelowViewport = !e.isIntersecting && e.boundingClientRect.top < 0;
    stickyUpdate();
  });
}, { threshold: 0 });
heroObs.observe(heroCta);
if (finalCta) {
  const finalObs = new IntersectionObserver((entries) => {
    entries.forEach(e => { finalCtaVisible = e.isIntersecting; stickyUpdate(); });
  }, { threshold: 0.1 });
  finalObs.observe(finalCta);
}

// Initialize UI
updatePackCards();
updateUI();

// ==================================================
// MATERIALS HOTSPOT INTERACTION
// ==================================================

// ==================================================
// HERO MINI-FAQ TOGGLE
// ==================================================

// ==================================================
// FAQ TOGGLE (smooth animated version)
// ==================================================
function toggleFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.faq-answer');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 0 20px';
  }
}

// Initialize open FAQ items
document.querySelectorAll('.faq-item.open .faq-answer').forEach(answer => {
  answer.style.maxHeight = answer.scrollHeight + 'px';
  answer.style.padding = '0 0 20px';
});

// ==================================================
// READING PROGRESS BAR
// ==================================================
let lastScrollY = 0;
const nav = document.querySelector('.nav');
window.addEventListener('scroll', function() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const progress = (scrollTop / docHeight) * 100;
  // Hide nav on scroll down, show on scroll up
  if (scrollTop > lastScrollY && scrollTop > 80) {
    nav.classList.add('nav-hidden');
  } else {
    nav.classList.remove('nav-hidden');
  }
  lastScrollY = scrollTop;
});

// ==================================================
// SCROLL REVEAL — IntersectionObserver
// ==================================================
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');

      // Trigger stat counter animation if this is a stat card
      const statEl = entry.target.querySelector('.stat-number[data-count]');
      if (statEl && !statEl.dataset.animated) {
        animateCounter(statEl);
        statEl.dataset.animated = 'true';
      }
    }
  });
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -40px 0px'
});

document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale').forEach(el => {
  revealObserver.observe(el);
});

// ==================================================
// ANIMATED STAT COUNTERS
// ==================================================
function animateCounter(el) {
  // Not every stat is a whole percentage — data-suffix and data-decimals let a
  // card count up to something like "2.4×" without a second code path.
  const target = parseFloat(el.dataset.count);
  const suffix = el.dataset.suffix !== undefined ? el.dataset.suffix : '%';
  const dp = parseInt(el.dataset.decimals || '0', 10);
  const duration = 1800;
  const start = performance.now();

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    // Ease out cubic
    const eased = 1 - Math.pow(1 - progress, 3);
    el.textContent = (target * eased).toFixed(dp) + suffix;

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      el.textContent = target.toFixed(dp) + suffix;
    }
  }

  requestAnimationFrame(update);
}

function openVideoModal(src) {
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.src = src;
  modal.style.display = 'flex';
  requestAnimationFrame(() => {
    modal.classList.add('active');
    video.play();
  });
  document.body.style.overflow = 'hidden';
}

function closeVideoModal(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('video-modal-close')) return;
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.pause();
  video.src = '';
  modal.classList.remove('active');
  setTimeout(() => { modal.style.display = 'none'; }, 300);
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeVideoModal({target: document.getElementById('videoModal'), currentTarget: document.getElementById('videoModal')});
});

function toggleMoreReviews() {
  const grid = document.querySelector('.sp-grid');
  const btn = document.getElementById('sp-show-more-btn');
  const isExpanded = grid.classList.contains('sp-expanded');
  if (!isExpanded) {
    grid.classList.add('sp-expanded');
    btn.classList.add('expanded');
    btn.innerHTML = 'Show Less <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    // Stagger the animation
    grid.querySelectorAll('.sp-more-item').forEach(function(item, i) {
      item.style.animationDelay = (i * 0.06) + 's';
    });
  } else {
    grid.classList.remove('sp-expanded');
    btn.classList.remove('expanded');
    btn.innerHTML = 'Show More Reviews <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }
}

// ==================================================
// TAPE LAYER REVEAL — materials panel
// Hover on pointer devices. Touch has no hover, so there the separation
// plays once when the tape scrolls into view, and tapping toggles it.
// ==================================================
(function () {
  var stage = document.getElementById('tape-layers');
  if (!stage) return;
  if (window.matchMedia('(hover: hover)').matches) {
    stage.addEventListener('mouseenter', function () { stage.classList.add('open'); });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('open'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        setTimeout(function () { stage.classList.add('open'); }, 420);
        setTimeout(function () { stage.classList.remove('open'); }, 3600);
        io.unobserve(e.target);
      });
    }, { threshold: 0.55 });
    io.observe(stage);
  }
  stage.addEventListener('click', function () { stage.classList.toggle('open'); });
})();

// ---- buy-box rotating review (moved out of the inline section script) ----
var reviewsList = [
      { name: 'Ethan X.', hook: '"Gentle on skin."', body: ' No redness at all and it opens my airway fully. I\'ve worn it every night for two months.' },
      { name: 'Marcus W.', hook: '"I can actually breathe through my nose now."', body: ' Chronic congestion my whole life. First night with these I slept straight through without once opening my mouth.' },
      { name: 'Sarah K.', hook: '"Doesn\'t peel off like the drugstore ones."', body: ' Every plastic strip I tried popped off by 2am. This one is still on when my alarm goes off.' },
      { name: 'David M.', hook: '"My wife says the snoring dropped off a cliff."', body: ' Mine was always worst during allergy season. These handle it better than anything else I\'ve tried.' },
      { name: 'Priya K.', hook: '"I wear them for runs too."', body: ' Bought them for sleep, ended up using them for training. Breathing through my nose the whole way now.' },
      { name: 'Kate N.', hook: '"Finally one that doesn\'t irritate."', body: ' Reactive skin here. Other strips left a red mark across my nose for hours. Zero issues with these.' },
      { name: 'Tom K.', hook: '"Deviated septum — this actually helps."', body: ' Not a cure, obviously, but the lift makes a real difference on my blocked side. Worth every dollar.' },
      { name: 'Ben H.', hook: '"Third month subscriber. Never going back."', body: ' Falling asleep faster and waking up without that dried-out, groggy feeling. Simplest upgrade I\'ve made.' },
      { name: 'Sofia M.', hook: '"Barely notice it\'s on."', body: ' It flexes with your face instead of sitting on top of it like a stiff plastic band. Comfortable enough to forget.' },
      { name: 'Laura W.', hook: '"Stopped waking up at 3am."', body: ' I think I was waking up to switch to mouth breathing. That doesn\'t happen anymore. Deep sleep is up on my watch.' }
    ];
    var currentReviewIndex = 0;
    function showReview(i) {
      // Wrap around in both directions
      if (i < 0) i = reviewsList.length - 1;
      if (i >= reviewsList.length) i = 0;
      currentReviewIndex = i;
      var r = reviewsList[i];
      var contentEl = document.getElementById('review-content');
      // Fade out, swap, fade in
      contentEl.style.opacity = '0';
      setTimeout(function() {
        contentEl.innerHTML = '<div class="mini-testimonial-top"><span class="mini-testimonial-stars">★★★★★</span><span class="mini-testimonial-name">' + r.name + '</span><span class="verified-badge">✓ Verified Buyer</span></div><div class="mini-testimonial-text"><strong>' + r.hook + '</strong>' + r.body + '</div>';
        contentEl.style.opacity = '1';
      }, 250);
      // Always show both arrows (we loop now)
      document.getElementById('review-prev').classList.remove('hidden');
      document.getElementById('review-next').classList.remove('hidden');
    }
    // Show a random review on each page load
    showReview(Math.floor(Math.random() * reviewsList.length));
